import useBootstrapData from '@/hooks/useBootstrapData'
import useSeti from '@/hooks/useSeti'

import type { TypeAheadConfigEndpoint } from './types'

export function useHotelNeighbourhoodNesting({
  typeAheadEndpoint,
  enabled = false,
}: {
  typeAheadEndpoint: TypeAheadConfigEndpoint
  enabled?: boolean
}) {
  const { isMobile } = useBootstrapData()
  const isHotelsV2 = typeAheadEndpoint === 'hotelsV2'
  const shouldShowNesting = enabled && isHotelsV2 && isMobile

  const setiVariant = useSeti({
    experimentCode: 'WEB_MWEB_HTL_SEARCH_SCREEN_NEIGHBOURHOOD_NESTING',
    shouldFireImpression: shouldShowNesting,
  })

  return shouldShowNesting && setiVariant === 'VARIANT'
}
